import React, { useState } from 'react';
import { Row, Col} from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { useGetContractById, useGetContractsPropsMaintainer, useGetPropsMaintainer } from '../../../../../../hooks/services/sBook/useOfContract';
import CLabel from '../../../../../Common/CLabel';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { forEach } from 'lodash-es';
import i18next from 'i18next';

const SidePanelContractInformation = (props) => {
    const { t } = useTranslation();

    const inputParam_IsPanelOpen = props.isPanelOpen;
    const inputParam_ContractId = props.contractId;
    const inputParam_SetterIsPanelOpen = props.setterIsPanelOpen;

    const { _contractProps: listContractsProps } = useSelector((state) => state.maintainerScope);
    const { _contractPropListValues: listContractsPropValues } = useSelector((state) => state.maintainerScope);

    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);

    const [contract, setContract] = useState(null);

    useGetContractById(inputParam_ContractId, contract, setContract)  
    useGetContractsPropsMaintainer(listContractsProps);
    useGetPropsMaintainer(listContractsPropValues);

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };
    
    const onClosePanel = () => {
        onDismissPanel();
    };

    const onRenderFooterContent = () => {
        return <div className='d-flex'>
            <DefaultButton onClick={onClosePanel}>{t('data-lang-btn-close')}</DefaultButton>
        </div> 
    };

    const getCustomProp = (listPropValues, column) => {
        let object = null;
        
        if (column.valType === "str") {
            object = { text: column.name, value: contract.l_props.find(x => x.contractPropId === column.id).strVal };
        }
        else if (column.valType === "num") {
            object = { text: column.name, value: contract.l_props.find(x => x.contractPropId === column.id).numVal };
        }
        else if (column.valType === "list") {
            const contractPropItem = contract.l_props.find(x => x.contractPropId === column.id);
            const aux_contractPropListItem = listPropValues.filter(x => x.contractPropId === column.id);
            const contractPropValueItem = contractPropItem ? aux_contractPropListItem.find(y => y.id === contractPropItem.cplId) : null;

            object = { text: column.name, value: contractPropValueItem ? contractPropValueItem.text : null };
        }
        else {
            object = { text: column.name, value: contract.l_props.find(x => x.contractPropId === column.id).strVal };
        }
    
        return <CLabel labelText={object.text} labelValue={object.value} />;
    }
    
    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-boxname-contractinformation') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <>
                {
                    contract &&
                    <>                          
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-code')} labelValue={contract.contractCode} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-name')} labelValue={contract.name} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">

                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-legalentitybuyername')} labelValue={contract.legalEntityBuyerName} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-legalentitysuppliername')} labelValue={contract.legalEntitySupplierName} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-businessunitName')} labelValue={contract.businessUnitName} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-segmentname')} labelValue={contract.segmentName} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-category')} labelValue={contract.categoryName} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-currencyname')} labelValue={contract.currencyName} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-adminuser')} labelValue={contract.adminUsername} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-startdate')} labelValue={moment(contract.startDate).format('DD/MM/YYYY')} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-enddate')} labelValue={moment(contract.endDate).format('DD/MM/YYYY')} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-amount')} labelValue={contract.amount && parseFloat(contract.amount.toFixed(2)).toLocaleString(i18next.language) } linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-endowment')} labelValue={contract.endowment} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-scope')} labelValue={contract.scope} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-status')} labelValue={contract.statusName} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        {
                            listContractsPropValues && listContractsProps && listContractsProps.filter(x => x.deactivate === false).map(obj => 
                                <Row className="pt-3">
                                    <Col xl={12}>
                                        {getCustomProp(listContractsPropValues, obj)}
                                    </Col>
                                </Row>
                            )
                        }
                    </>
                }
                </>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

export default SidePanelContractInformation;